import { jsx as e } from "react/jsx-runtime";
import { forwardRef as m } from "react";
import p from "./styles.module.less.js";
const a = m((r, t) => {
  var o;
  const { text: s } = r;
  return /* @__PURE__ */ e("div", { ref: t, ...r.props, className: `${p.inputError} ${((o = r.props) == null ? void 0 : o.className) || ""}`, children: s });
});
a.displayName = "InputError";
export {
  a as InputError
};
